var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-media', {
    staticClass: "pb-3 pt-3",
    attrs: {
      "tag": "li"
    },
    scopedSlots: _vm._u([{
      key: "aside",
      fn: function () {
        return [_c('b-img', {
          attrs: {
            "src": _vm.itemData.imageLink || _vm.itemData.custom.shopImage,
            "width": "64",
            "alt": "placeholder"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('h6', {
    staticClass: "mt-0 mb-1 text-left"
  }, [_vm._v(" " + _vm._s(_vm.itemData.name || _vm.itemData.providerName) + " ")]), _c('p', {
    staticClass: "mb-0 text-left"
  }, [_vm._v(" " + _vm._s(_vm.itemData && _vm.itemData.description || _vm.itemData && _vm.itemData.custom && _vm.itemData.custom.shopNumber) + " ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }